import React from "react";
import { useNavigate } from "react-router-dom";
import classes from "./FormsButton.module.css";

function FormsButton({ heading, options, classname }) {
  const navigate = useNavigate();
  function handleClick(href) {
    if (href === "") {
      return;
    }
    navigate(href);
  }
  return (
    <div className={classname}>
      <h3 className={classes.h3}>{heading}</h3>
      <div
        className="d-flex flex-wrap mx-auto"
        style={{ width: "1050px", gap: "40px", padding: "20px 0 50px 0" }}
      >
        {options?.map((option, i) => (
          <button
            key={i}
            className={classes.button}
            onClick={() => handleClick(option.href)}
          >
            {option.name}
          </button>
        ))}
        {/* {options?.map((option, i) => (
          <button key={i} className={classes.button} onClick={option.onclick}>
            {option.name}
          </button>
        ))} */}
      </div>
    </div>
  );
}

export default FormsButton;
